<template>
  <div class="attachment-cell" :class="{ 'has-attachments': params.data.has_attachments }">
    <svg
      v-if="params.data.has_attachments"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.375 5.06249V12.9975C12.375 14.565 11.2275 15.96 9.6675 16.11C7.875 16.2825 6.375 14.88 6.375 13.125V3.85499C6.375 2.87249 7.08 1.97999 8.055 1.88249C9.18 1.76999 10.125 2.64749 10.125 3.74999V11.625C10.125 12.0375 9.7875 12.375 9.375 12.375C8.9625 12.375 8.625 12.0375 8.625 11.625V5.06249C8.625 4.75499 8.37 4.49999 8.0625 4.49999C7.755 4.49999 7.5 4.75499 7.5 5.06249V11.52C7.5 12.5025 8.205 13.395 9.18 13.4925C10.305 13.605 11.25 12.7275 11.25 11.625V3.87749C11.25 2.30999 10.1025 0.914987 8.5425 0.764987C6.7575 0.592487 5.25 1.99499 5.25 3.74999V12.9525C5.25 15.105 6.825 17.0325 8.97 17.235C11.4375 17.46 13.5 15.54 13.5 13.125V5.06249C13.5 4.75499 13.245 4.49999 12.9375 4.49999C12.63 4.49999 12.375 4.75499 12.375 5.06249Z"
      />
    </svg>

    <span v-else>N/A</span>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({})
</script>

<style lang="scss" scoped>
.attachment-cell {
  &.has-attachments {
    text-align: center;
  }

  svg path {
    fill: var(--r-secondary-1);
  }
}
</style>
